// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .box-catalog-modal .ant-modal-body {
  min-height: 50vh;
  max-height: 70vh;
  overflow-y: auto;
}
/*# sourceMappingURL=BoxRestrictionsModal.css.map */`, "",{"version":3,"sources":["webpack://./BoxRestrictionsModal.less","webpack://./src/components/BoxRestrictions/BoxRestrictionsModal/BoxRestrictionsModal.less"],"names":[],"mappings":"AAAA;EAGI,gBAAA;EACA,gBAAA;EACA,gBAAA;ACDJ;AACA,mDAAmD","sourcesContent":[".presize-root { \n .box-catalog-modal {\n  .ant-modal-body {\n    min-height: 50vh;\n    max-height: 70vh;\n    overflow-y: auto;\n  }\n}\n \n}",".presize-root .box-catalog-modal .ant-modal-body {\n  min-height: 50vh;\n  max-height: 70vh;\n  overflow-y: auto;\n}\n/*# sourceMappingURL=BoxRestrictionsModal.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
